import {component} from '../../form/Constant'

export const hospitalKeys = {
    basicInformation: 'basicInformation',
    groupBy: 'groupBy',
    name: 'name',
    description: 'description',
    hospitalNumber: 'hospitalNumber',

    hospitalLogo: 'hospitalLogo',
    logo: 'logo',
    displaySetting: 'displaySetting',
    preview: 'preview',

    contactInformation: 'contactInformation',
    address: 'address',
}

export const hospitalFilterList = [
    {
        key: hospitalKeys.contactInformation,
        children: [
            {
                key: hospitalKeys.address,
                hideHeader: true,
                component: component.address,
            },
        ],
    },
]

export const displaySettingOptions = [
    {value: 'imageOnly', label: 'Image Only'},
    {value: 'textOnly', label: 'Text Only'},
    {value: 'textAndImage', label: 'Text And Image'},
]

export const toPostDataKeys = [
    hospitalKeys.groupBy,
    hospitalKeys.name,
    hospitalKeys.hospitalNumber,
    hospitalKeys.description,
    hospitalKeys.displaySetting,
    hospitalKeys.address,
]

export const hospitalList = [
    {
        key: hospitalKeys.basicInformation,
        label: 'Basic Information',
        description: ' Fill in the following information to create a hospital',
        required: true,
        children: [
            {
                key: hospitalKeys.groupBy,
                label: 'Group By Organization',
                component: component.hospitalOptions,
                placeholder:
                    'Leave this blank if this hospital is also the main group',
                description: (
                    <p className="py-2">
                        <i className="pi pi-info-circle mr-2"></i>
                        <span>
                            "Group by Organization" organizes data by grouping
                            it under a primary organization, which may have
                            sub-hospitals or branches
                        </span>
                    </p>
                ),
            },
            {
                key: hospitalKeys.name,
                label: 'Hospital Name',
                component: component.inputText,
                placeholder: 'Input hospital name',
                required: true,
            },
            {
                key: hospitalKeys.hospitalNumber,
                label: 'Hospital Number',
                component: component.inputText,
                placeholder: 'Input hospital number',
                required: true,
            },
            {
                key: hospitalKeys.description,
                label: 'Description',
                component: component.inputText,
                placeholder: 'Input hospital description',
            },
        ],
    },
    {
        key: hospitalKeys.hospitalLogo,
        label: 'Hospital Logo',
        description: `The required image ratio is 16:9. 
        The standard size of the image is 120px x 54px.`,
        children: [
            {
                key: hospitalKeys.logo,
                label: 'Logo',
                component: component.fileUpload,
                extraData: {
                    dimensionHeight: 16,
                    dimensionWidth: 9,
                },
            },
            {
                key: hospitalKeys.displaySetting,
                label: 'Display Setting',
                component: component.dropdown,
                placeholder:
                    'Select settings to display the hospital name and logo',
                options: displaySettingOptions,
                defaultValue: 'textAndImage',
                description: (
                    <p className="py-2">
                        <i className="pi pi-info-circle mr-2"></i>
                        <span>
                            This setting allows you to customize how the logo
                            and text are displayed providing flexibility in
                            visual presentation to suit different preferences or
                            branding needs
                        </span>
                    </p>
                ),
            },
            {
                key: hospitalKeys.preview,
                label: 'Preview',
            },
        ],
    },
    {
        key: hospitalKeys.contactInformation,
        label: 'Contact Information',
        description: 'Fill in the hospital contact details.',
        note: '',
        required: true,
        children: [
            {
                key: hospitalKeys.address,
                hideHeader: true,
                component: component.address,
                className: 'col-12 grid  px-0',
                childrenClassName: 'md:col-6 col-12 px-1',
            },
        ],
    },
]
